import { isNudgytAgentClient } from '../helpers/utils';
import { useModelLipsync } from './useModelLipsync';
import { useModelViseme15Lipsync } from './useModelViseme15Lipsync';

/** Routes lipsync to viseme15 (Nudgyt Agent) or Convai indexed visemes. */
export const useAvatarLipsync = ({ client, scene }) => {
  const useViseme15 = isNudgytAgentClient(client);

  useModelLipsync({ client, scene, enabled: !useViseme15 });
  useModelViseme15Lipsync({ client, scene, enabled: useViseme15 });
};
